var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThief(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thief",
    transform: "translate(-0.071 -0.332)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1254",
    "data-name": "Ellipse 1254",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(0.071 0.332)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13313",
    "data-name": "Path 13313",
    d: "M27.024,87.155A12.379,12.379,0,1,0,37.692,68.5c-.359,0-.713.019-1.064.049A30.77,30.77,0,0,0,27.024,87.155ZM39.232,77.19a3.521,3.521,0,1,1-3.521,3.521A3.521,3.521,0,0,1,39.232,77.19Z",
    transform: "translate(-21.076 -53.422)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13314",
    "data-name": "Path 13314",
    d: "M187.044,74.193a12.378,12.378,0,1,0-.107,13.532,30.974,30.974,0,0,0,.107-13.532ZM175.305,84.232a3.521,3.521,0,1,1,3.521-3.521A3.521,3.521,0,0,1,175.305,84.232Z",
    transform: "translate(-128.099 -53.422)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13315",
    "data-name": "Path 13315",
    d: "M268.152,100.9a30.913,30.913,0,0,1-.8,7.014,12.319,12.319,0,0,0,2.068-6.85,12.45,12.45,0,0,0-.15-1.925,28.82,28.82,0,0,0-1.16-3.617,12.411,12.411,0,0,0-.651-1.141A30.889,30.889,0,0,1,268.152,100.9Z",
    transform: "translate(-208.511 -73.609)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13316",
    "data-name": "Path 13316",
    d: "M20.958,87.327a30.77,30.77,0,0,1,9.6-18.61,12.38,12.38,0,0,0-10,6.781,28.811,28.811,0,0,0-1.167,3.638,12.475,12.475,0,0,0-.147,1.912A12.319,12.319,0,0,0,20.958,87.327Z",
    transform: "translate(-15.011 -53.594)",
    fill: "#ffe454"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1196",
    "data-name": "Ellipse 1196",
    cx: 3.521,
    cy: 3.521,
    r: 3.521,
    transform: "translate(14.635 23.769)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1197",
    "data-name": "Ellipse 1197",
    cx: 3.521,
    cy: 3.521,
    r: 3.521,
    transform: "translate(43.685 23.769)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThief);
export default __webpack_public_path__ + "static/media/thief.b519a1884867884f242ffca9c5a655eb.svg";
export { ForwardRef as ReactComponent };